<div class="p-3" *ngIf="viewMode == 'edit'">
  <div class="row">
    <div class="ml-auto mt-3 mt-md-0 d-flex align-items-center p-1">
      <button class="btn btn-info" style="width: 100%;" (click)="add()" type="button">{{'prodotti.Add' | translate}}</button>
<!--      <button class="btn btn-warning " style="width: 100%;" (click)="MostraEliminati()" type="button">{{eliminati? 'Nascondi Eliminati':'Mostra Eliminati' }}</button>-->
    </div>

  </div>
</div>

<div class="table-responsive" *ngIf="viewMode == 'edit'">
  <table class="table bg-white table-hover align-middle mb-0">
    <thead>
    <tr>
      <th>{{'prodotti.title' | translate}}</th>
      <th>{{'prodotti.subtitle' | translate}}</th>
      <th>{{'prodotti.image' | translate}}</th>
      <th>{{'prodotti.Actions' | translate}}</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let item of dettagli" >
      <td class="align-middle">
        <span *ngIf="!item.modifica" >
          {{ item.nome }}
        </span>
        <span *ngIf="item.modifica">
          <input [(ngModel)]="item.nome" placeholder="{{'prodotti.title' | translate}}" type="text" name="nominativo" class="form-control">
        </span>
      </td>
      <td class="align-middle" >
        <span *ngIf="!item.modifica" >
          {{ item.descrizione }}
        </span>
        <span *ngIf="item.modifica">
          <input [(ngModel)]="item.descrizione" placeholder="{{'prodotti.subtitle' | translate}}" type="text" name="codice_univoco" class="form-control">
        </span>
      </td>
      <td class="align-middle" >
        <span *ngIf="!item.modifica" >
          <img *ngIf="item.id_immagine" [src]="apiPaths.getBaseAPI()+'/file/image/'+item.id_immagine.toString()" style="height: 100px; width: 100px;" />
        </span>
        <div *ngIf="item.modifica" class="btn btn-info waves-effect waves-light">
          <span>Upload Anonther Image</span>
          <input type="file" class="upload" (change)="schedacambiata($event, item)">
        </div>
      </td>
      <td class="align-middle">
        <a *ngIf="!item.modifica"  href="javascript:void(0)" ngbTooltip="Modifica" class="link font-16 text-info font-medium mr-2"
           (click)='edit(item)'>
          <i-feather name="edit-3" class="feather-sm"></i-feather>
        </a>
        <a *ngIf="item.modifica" href="javascript:void(0)" ngbTooltip="Salva" class="link font-16 text-success font-medium mr-2" (click)='edit(item)'>
          <i-feather name="check" class="feather-sm"></i-feather>
        </a>
        <a *ngIf="!item.modifica" href="javascript:void(0)" ngbTooltip="Elimina"
           class="link font-16 text-danger font-weight-bold" (click)='delete(item)'>
          <i-feather name="trash-2" class="feather-sm"></i-feather>
        </a>
        <a *ngIf="item.modifica" href="javascript:void(0)" ngbTooltip="annulla"
           class="link font-16 text-danger font-weight-bold" (click)='delete(item)'>
          <i  class="fas fas fa-times"></i>
        </a>
      </td>
    </tr>
    </tbody>
  </table>
</div>


<div class="d-flex justify-content-center" *ngIf="viewMode == 'detail'">
  <div class="card border-warning border-bottom border-top border-left border-right m-t-40" style="width: 95%; border-radius:40px;">
    <div class="card-body">
      <div class="row">
        <div class="col-4" *ngFor="let dettaglio of dettagli">
          <div class="card border-left border-warning" style="border-radius:40px;">
            <div class="card-body">
              <h4 class="card-title">{{dettaglio.nome}}</h4>
              <h6 class="card-subtitle">{{dettaglio.descrizione}}</h6>
              <img [src]="apiPaths.getBaseAPI()+'/file/image/'+dettaglio.id_immagine.toString()" class="img-fluid col-12">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
